import axios from 'axios';

export const fetchAllActivities = () => axios.get('/api/activities/all');

export const fetchAllActivitiesAdmin = () => axios.get('/api/activities/admin/all');

export const createActivity = (data) => axios.post('/api/activities', data);

export const updateActivity = (id, data) => axios.put(`/api/activities/${id}`, data);

export const deleteActivity = (id) => axios.delete(`/api/activities/${id}`);
